export enum EligibilityStatus {
    /**
     * The user has completed onboarding for that plan type or a plan type that includes its functionality (eg a full
     * MFP user would be active for budgets)
     */
    ACTIVE = 'ACTIVE',
    /**
     * The user has initiated but not finished onboarding for that plan type or a plan type that includes its
     * functionality (eg a full MFP user would be active for budgets)
     */
    ONBOARDING = 'ONBOARDING',
    /**
     * The user does not have a plan of that type but is eligible to create one
     */
    ELIGIBLE = 'ELIGIBLE',
    /**
     * The user does not have a plan of that type and is ineligible to create one
     */
    INELIGIBLE = 'INELIGIBLE'
}

export interface EligibilityModel {
    userStatus: EligibilityStatus;
    entryUrl: string;
    reasonCodes?: string[];
}
